import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44534a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second flex-grow user-tab-element self-center" }
const _hoisted_2 = { class: "third working-site-users-buttons flex self-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fourth working-site-users-buttons flex self-center" }, null, -1))
const _hoisted_4 = { class: "font-bold user-tab-element suspend mr-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_RemoveWorkingSiteUserAssignment = _resolveComponent("RemoveWorkingSiteUserAssignment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["user-assigned-working-site mb-2 flex text-left overflow-hidden", { 'bg-primary-50': _ctx.modelValue.isEnabled, 'bg-secondary-50': !_ctx.modelValue.isEnabled }])
        }, [
          _createVNode(_component_router_link, {
            class: "first flex-grow font-bold user-tab-element self-center",
            to: `/working-sites/${_ctx.modelValue.workingSite.id}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.modelValue.workingSite.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.modelValue.isForeman ? 'Capo cantiere' : 'Operaio'), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.moment.unix(_ctx.modelValue.createdTs).format("DD/MM/YYYY")), 1),
          _hoisted_3,
          _createElementVNode("button", {
            class: "ml-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleUserAssignmentSospension()))
          }, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(!_ctx.modelValue.isEnabled ? 'Annulla sospensione' : 'Sospendi'), 1)
          ]),
          _createElementVNode("button", null, [
            _createElementVNode("h3", {
              class: "font-bold user-tab-element delete-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRemoveUserDialog()))
            }, "Elimina")
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true),
    (_ctx.removeUser)
      ? (_openBlock(), _createBlock(_component_RemoveWorkingSiteUserAssignment, {
          key: 2,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideRemoveUserDialog())),
          "working-site-id": _ctx.modelValue.workingSite.id,
          "working-site-name": _ctx.modelValue.workingSite.name,
          "user-id": _ctx.modelValue.userId,
          "user-name": ''
        }, null, 8, ["working-site-id", "working-site-name", "user-id"]))
      : _createCommentVNode("", true)
  ], 64))
}